import Layout from '../components/layout';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import LogoImage from '../../public/Time-to-Rock-Festival-custom-2026.webp';
import React from 'react';
import { useRouter } from 'next/router';
import { ContentDisplay } from '../components/contentDisplay';
export default function GdprPolicyPage() {
    var _a;
    const { locale } = useRouter();
    const langCode = (_a = locale === null || locale === void 0 ? void 0 : locale.substring(0, 2)) !== null && _a !== void 0 ? _a : 'en';
    const contentKey = 'gdpr policy page';
    return (<Layout>
      <Image src={LogoImage.src} alt="Time To Rock festival 3 - 6 Juli 2026" style={{ width: '100%' }}/>

      <Row>
        <Col md={{ offset: 2, span: 8 }} sm={12}>
          <ContentDisplay contentKey={contentKey} languageCode={langCode}/>
        </Col>
      </Row>
    </Layout>);
}
